export const SITE = {
  brand: "Incubatour Experiences Lab",
  parent: "Incubatour",
  rnt: "278668",
  whatsappNumber: "573158475169", // +57 315 8475169
  whatsappDisplay: "+57 315 847 5169",
  email: "mlatorre@incubatour.com",
  origin: "Colombia",
};

export const buildWhatsAppUrl = (text) => {
  const msg = encodeURIComponent(
    text || "Hola, me gustaría conversar con Incubatour Experiences Lab sobre el diseño de una experiencia."
  );
  return `https://wa.me/${SITE.whatsappNumber}?text=${msg}`;
};
